// network.service.ts
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Network } from '@capacitor/network';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private onlineSubject = new BehaviorSubject<boolean>(true);
  online$ = this.onlineSubject.asObservable();

  constructor() {
    this.init();
  }

  private async init() {
    const status = await Network.getStatus();
    this.onlineSubject.next(status.connected);

    Network.addListener('networkStatusChange', (status) => {
      this.onlineSubject.next(status.connected);
    });
  }
}